import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/skrkl/work/ali_fiverr_coach/src/app/landing-page/components/LandingPageInteractive.tsx");
